import transportRouteMap from "@/assets/transport-route-map.png";
import footerBg from "@/assets/footer-bg.jpg";

export function Transport() {
  return (
    <div className="min-h-screen bg-background">
      <article className="pt-24 md:pt-32 pb-20 mx-auto px-6 max-w-175">
        <h1 className="font-display text-4xl text-foreground text-center mb-12">
          Transport
        </h1>

        <p className="font-body text-muted-foreground leading-relaxed mb-12">
          ⚠️ <strong>Uber and Lyft are NOT available in Hood River.</strong> We strongly recommend using the provided shuttle service or arranging your own transportation in advance.
        </p>

        <div className="mb-12">
          <h2 className="font-display text-xl md:text-2xl text-foreground mb-6">
            Shuttle Service
          </h2>
          <p className="font-body text-muted-foreground leading-relaxed mb-6">
            We'll provide complimentary shuttle service between the main hotels and the venue on wedding day.
          </p>
          <img src={transportRouteMap} alt="Transport route from Portland Hyatt Centric to The Orchard wedding venue" className="my-10 w-full lg:w-[120%] lg:-ml-[10%] max-w-none h-auto" />

          <div className="space-y-6">
            <div>
              <p className="font-display text-lg text-foreground mb-2">To the Venue</p>
              <ul className="font-body text-muted-foreground space-y-1 list-disc pl-5">
                <li>1:20pm arrive at <a href="https://maps.app.goo.gl/VmKLwF12jrAGkiEg7" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Hyatt Centric Downtown Portland</a> (valet parking near hotel entrance)</li>
                <li>1:40pm depart <a href="https://maps.app.goo.gl/VmKLwF12jrAGkiEg7" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Hyatt Centric Downtown Portland</a></li>
                <li>2:55pm arrive at <a href="https://maps.app.goo.gl/XXq6oGMMfJHPyj8h9" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Holiday Inn Express Hood River</a></li>
                <li>3:05pm depart from <a href="https://maps.app.goo.gl/XXq6oGMMfJHPyj8h9" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Holiday Inn Express Hood River</a></li>
                <li>3:15pm arrive at <a href="https://maps.app.goo.gl/YeV4LiMLm3S3mfwa8" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">714 Cascade Ave</a></li>
                <li>3:20pm depart from <a href="https://maps.app.goo.gl/YeV4LiMLm3S3mfwa8" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">714 Cascade Ave</a></li>
                <li>3:35pm arrive at <a href="https://maps.app.goo.gl/fZ4rutxcpNSvAjwh7" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">the Orchard</a></li>
              </ul>
            </div>
            <div>
              <p className="font-display text-lg text-foreground mb-2">Leaving the Venue</p>
              <ul className="font-body text-muted-foreground space-y-1 list-disc pl-5">
                <li><span className="font-semibold text-foreground">9:45pm</span> depart <a href="https://maps.app.goo.gl/4DtYooJ7RTqyM4Nf9" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">the Orchard</a></li>
                <li>Quick dropoff at <a href="https://maps.app.goo.gl/YeV4LiMLm3S3mfwa8" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">714 Cascade Ave</a></li>
                <li>Quick dropoff at <a href="https://maps.app.goo.gl/oRYegocN5ji3JVJK7" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Holiday Inn Express Hood River</a></li>
                <li>End at <a href="https://www.hyatt.com/shop/rooms/pdxct?location=Hyatt%20Centric%20Downtown%20Portland&checkinDate=2026-08-27&checkoutDate=2026-08-29&rooms=1&adults=1&kids=0&corp_id=g-ajwb" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 transition-colors">Hyatt Centric Downtown Portland</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="font-display text-xl md:text-2xl text-foreground mb-6">
            Driving & Directions
          </h2>
          <p className="font-body text-muted-foreground"><strong><a href="https://maps.app.goo.gl/fZ4rutxcpNSvAjwh7" className="text-primary underline hover:text-primary/80 transition-colors">The Orchard</a></strong></p>
          <p className="font-body text-muted-foreground">
            2124 OR-35<br />
            Hood River, OR 97031
          </p>
        </div>

        <div>
          <h2 className="font-display text-xl md:text-2xl text-foreground mb-6">
            Parking
          </h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            Self-parking is available at the venue.
          </p>
        </div>
      </article>

      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
